import React from "react";
import clsx from "clsx";
import { SCORE_THRESHOLD } from "../../TrackPageV3";

import styles from "./score-dot.module.scss";

interface ScoreDotPropsType {
  value: number | null;
  className?: string;
}

const ScoreDot: React.FC<ScoreDotPropsType> = ({ value, className }) => {
  const hasValue = value !== null;
  const isAboveThreshold = value >= SCORE_THRESHOLD;

  return (
    <span
      className={clsx(
        styles["score-dot"],
        {
          [styles["score-dot-above"]]: isAboveThreshold,
          [styles["score-dot-below"]]: !isAboveThreshold,
          [styles["empty-score-dot"]]: !hasValue,
        },
        className
      )}
    />
  );
};

export default ScoreDot;
